module.exports = __webpack_public_path__ + "static/media/anti-fish-hopper.9ae480d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/anti-fish-hopper.png
// module id = 484
// module chunks = 0